import { useFormContext } from "./formElements";
import { Button, Form, InputGroup, Table, Alert } from "react-bootstrap";
import { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash } from "@fortawesome/free-solid-svg-icons";
import { ThText, ThSpan, getSectionEnds, isSectionEnd } from "./AerationTable";

export function BuildingMeasurementsTable(props) {
  const element = props.value;
  const { onChange } = useFormContext();
  const header = element.table_head;
  const values = element.value;
  const rowTemplate = element.columns;
  const [customFloor, setCustomFloor] = useState("");
  const [error, setError] = useState(null);
  const sectionEnds = getSectionEnds(header);

  const getRow = (index) => {
    let cols = [];
    const data = values[index];

    const handleDeleteRow = () => {
      element.value.splice(index, 1);
      onChange({ ...element });
    };

    for (let x = 0; x < Object.keys(data).length; x++) {
      const column = data[x];
      const thickBorderClass = sectionEnds.includes(x)
        ? "thick-border-right"
        : "";

      if (column.type === "select") {
        cols.push(
          <td className={"p-0 border-2 " + thickBorderClass} key={x}>
            <Form.Select
              className={"border-0 bg-transparent "}
              aria-label={column.label}
              value={column.value}
              onChange={(event) => {
                const newVal = event.target.value;
                data[x] = { ...column, value: newVal };
                element.value[index] = data;
                onChange(element);
              }}
            >
              <option value=""></option>
              {column.options?.map((opt, i) => (
                <option key={i} value={opt.value}>
                  {opt.value} - {opt.label}
                </option>
              ))}
            </Form.Select>
          </td>
        );
      } else {
        cols.push(
          <td className={"p-0 border-2 " + thickBorderClass} key={x}>
            <Form.Control
              className={"border-0 bg-transparent "}
              type={column.type}
              value={column.value}
              placeholder={column.label}
              onChange={(event) => {
                const newVal = event.target.value;
                data[x] = { ...column, value: newVal };
                element.value[index] = data;
                onChange(element);
              }}
            />
          </td>
        );
      }
    }

    return (
      <tr key={index}>
        {cols}
        <td>
          <div className={"btn-close"} onClick={handleDeleteRow}></div>
        </td>
      </tr>
    );
  };

  const onChangeHeaderLabel = (index, event) => {
    element.table_head[index].label = event.target.value;
    onChange({ ...element });
  };

  const onChangeSubHeaderLabel = (headerIndex, subIndex, event) => {
    element.table_head[headerIndex].value[subIndex].label = event.target.value;
    onChange({ ...element });
  };

  const addColumnToSection = (headerIndex) => {
    let startIdx = 0;
    for (let i = 0; i < headerIndex; i++) {
      const h = header[i];
      startIdx += h.type === "text" ? 1 : h.value?.length ?? 0;
    }
    const sectionLen = header[headerIndex].value?.length ?? 0;

    const insertPosInSection = sectionLen > 0 ? sectionLen - 1 : 0;
    const insertPos = startIdx + insertPosInSection;

    const newSubLabel = `Nowa kolumna ${sectionLen + 1}`;
    const newSub = { label: newSubLabel, type: "text" };

    const oldSubs = header[headerIndex].value ?? [];
    const newSubs = [
      ...oldSubs.slice(0, insertPosInSection),
      newSub,
      ...oldSubs.slice(insertPosInSection),
    ];
    header[headerIndex].value = newSubs;

    const newColTemplate = { type: "text", label: newSubLabel, value: "" };

    element.value = values.map((row) => {
      const before = row.slice(0, insertPos);
      const after = row.slice(insertPos);
      return [...before, { ...newColTemplate }, ...after];
    });

    element.columns = [
      ...element.columns.slice(0, insertPos),
      newSub,
      ...element.columns.slice(insertPos),
    ];

    onChange({ ...element });
  };

  const removeColumnFromSection = (headerIndex, subIndex) => {
    let startIdx = 0;
    for (let i = 0; i < headerIndex; i++) {
      const h = header[i];
      startIdx += h.type === "text" ? 1 : h.value?.length ?? 0;
    }
    const targetIdx = startIdx + subIndex;

    header[headerIndex].value = header[headerIndex].value.filter(
      (_s, i) => i !== subIndex
    );

    element.columns = element.columns.filter((_c, i) => i !== targetIdx);

    element.value = element.value.map((row) => {
      const before = row.slice(0, targetIdx);
      const after = row.slice(targetIdx + 1);
      return [...before, ...after];
    });

    onChange({ ...element });
  };

  const addGarage = () => {
    const copy = rowTemplate.map((col) => ({ ...col }));
    copy[0].value = element.value[0][0].value - 1;
    element.value = [copy, ...element.value];
    onChange(element);
  };

  const addFloor = () => {
    const copy = rowTemplate.map((col) => ({ ...col }));
    copy[0].value = element.value[element.value.length - 1][0].value + 1;
    element.value = [...element.value, copy];
    onChange(element);
  };

  const addCustomFloor = (value) => {
    const newRow = rowTemplate.map((col) => ({ ...col }));
    newRow[0].value = value;

    const exists = element.value.some((row) => row[0].value === value);
    if (exists) {
      setError(`Kondygnacja ${value} już istnieje.`);
      return;
    }

    const insertIndex = element.value.findIndex((row) => row[0].value > value);

    let newArray;
    if (insertIndex === -1) {
      newArray = [...element.value, newRow];
    } else {
      newArray = [
        ...element.value.slice(0, insertIndex),
        newRow,
        ...element.value.slice(insertIndex),
      ];
    }

    element.value = newArray;
    onChange(element);
  };

  return (
    <div className="mt-3">
      <div className="aeration_table">
        <Table striped bordered hover className="aeration-table" size="sm">
          <thead>
            <tr>
              {header.map((h, index) =>
                h.type === "text" ? (
                  <ThText
                    key={index}
                    onChange={(event) => onChangeHeaderLabel(index, event)}
                    text={h.label}
                    className="text-center thick-border-right"
                  />
                ) : h.type === "rowSpan" ? (
                  <ThSpan
                    key={index}
                    label={h.label}
                    colSpan={h.value?.length ?? 0}
                    onChange={(event) => onChangeHeaderLabel(index, event)}
                    onAdd={() => addColumnToSection(index)}
                  />
                ) : null
              )}
            </tr>

            <tr className="text-center">
              {header.map((h, index) =>
                h.type === "rowSpan"
                  ? h.value.map((sub, subIndex) => (
                      <th
                        key={`${index}-${subIndex}`}
                        className={`text-center p-0 ${
                          isSectionEnd(subIndex, h) ? "thick-border-right" : ""
                        }`}
                      >
                        <Form.Control
                          className={"border-0 p-1 bg-transparent aeration-header-control"}
                          as="textarea"
                          value={sub.label}
                          onChange={(event) =>
                            onChangeSubHeaderLabel(index, subIndex, event)
                          }
                        />
                      </th>
                    ))
                  : null
              )}
            </tr>
          </thead>
          <tbody>
            {values.map((row, index) => getRow(index))}
            <tr>
              {header.map((h, hIndex) =>
                h.type === "text" ? (
                  <td
                    key={`del-${hIndex}`}
                    className="p-0 border-2 thick-border-right"
                  />
                ) : h.type === "rowSpan" ? (
                  h.value.map((sub, subIndex) => (
                    <td
                      key={`del-${hIndex}-${subIndex}`}
                      className={`p-1 border-2 ${
                        isSectionEnd(subIndex, h) ? "thick-border-right" : ""
                      }`}
                    >
                      {isSectionEnd(subIndex, h) || sub.deleteable === false ? null : (
                        <Button
                          variant="outline-danger"
                          size="sm"
                          onClick={() =>
                            removeColumnFromSection(hIndex, subIndex)
                          }
                        >
                          <FontAwesomeIcon icon={faTrash} />
                        </Button>
                      )}
                    </td>
                  ))
                ) : null
              )}
              <td />
            </tr>
          </tbody>
        </Table>
      </div>

      {error && (
        <Alert variant="danger" className="mt-2">
          {error}
        </Alert>
      )}

      <InputGroup className="mb-3">
        <Button
          variant="outline-primary"
          onClick={() => {
            const floorNum = parseInt(customFloor, 10);
            if (!isNaN(floorNum)) {
              addCustomFloor(floorNum);
              setCustomFloor("");
            }
          }}
        >
          Dodaj
        </Button>
        <Form.Control
          placeholder="numer kondygnacji"
          value={customFloor}
          onChange={(e) => {
            setCustomFloor(e.target.value);
            if (error) setError(null);
          }}
          type="number"
          min={-10}
          max={30}
        />
        <Button variant="outline-primary" onClick={() => addGarage()}>
          Dodaj garaż
        </Button>
        <Button variant="outline-primary" onClick={() => addFloor()}>
          Dodaj piętro
        </Button>
      </InputGroup>
    </div>
  );
}
